
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/card",
      function () {
        return require("private-next-pages/card.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/card"])
      });
    }
  